'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var useMobileBool = function useMobileBool() {
  var _useState = React.useState(NaN),
      _useState2 = slicedToArray['default'](_useState, 2),
      windowWidth = _useState2[0],
      setWindowWidth = _useState2[1];

  React.useEffect(function () {
    setWindowWidth(window.innerWidth);

    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowWidth < 1024;
};

exports.useMobileBool = useMobileBool;